import React, {useEffect} from 'react';
import Dialog from '../adapters/Dialog'
import Button from '../adapters/Button';

import {useSelector, useDispatch} from "react-redux";
import {applicationSelector, closeConfirm, rejectConfirm, resolveConfirm} from '../../redux/application';
import {Typography} from "@material-ui/core";


export default function ConfirmDialog() {

  const dispatch = useDispatch();
  const {confirm} = useSelector(applicationSelector);

  useEffect(()=> {
     return () => {
       console.log('unmount!');
       dispatch(closeConfirm())
     }
   }, []);

   const content =
     <Typography variant="h6">{confirm.message}</Typography>

   const actions = <React.Fragment>
     <Button onClick={() => dispatch(resolveConfirm())}>{confirm.okTitle} </Button>
     <Button onClick={() => dispatch(rejectConfirm())}>{confirm.cancelTitle} </Button>
   </React.Fragment>;

   return (
     <Dialog
       maxWidth="xs"
       open={confirm.open}
       title={confirm.title}
       content={content}
       actions={actions}
     />)


}